module.exports = "/components/components/currencySelectorComponent-77be02.html";